import { ofType } from 'redux-observable';
import { debounceTime, switchMap, map, catchError } from 'rxjs/operators';
import { from, of } from 'rxjs';
import { SEARCH_VENUE_NAMES, EPIC_ERROR } from 'Constants/redux';
import service from 'Api/service';
import { receiveVenueNames } from 'Actions';

const SearchVenueNamesEpic = (action$) =>
  action$.pipe(
    ofType(SEARCH_VENUE_NAMES),
    debounceTime(500),
    switchMap(({ query }) =>
      from(
        service.get(
          `${
            import.meta.env.VITE_API_DOMAIN
          }/api/venues/search?query=${encodeURIComponent(query)}`
        )
      ).pipe(
        map((response) => receiveVenueNames(response.data.names)),
        catchError(() => of({ type: EPIC_ERROR }))
      )
    )
  );

export default SearchVenueNamesEpic;
